import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { DEAL_HISTORY } from '../../constants/columns';
import { useParams } from 'react-router-dom';

// components
import EmptyData from '../../components/EmptyData/EmptyData';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/buttonIcons/addDeal.svg';
import getDealHistory from '../../api/deals/getDealHistory';

const columns = DEAL_HISTORY;

const DealHistory = () => {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns,
      data: history,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    await getDealHistory({ id })
      .then((res) => {
        setHistory(res?.data || []);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    init();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <EmptyData
          title={`История изменений (${history.length})`}
          subtitle={'По этой сделке пока нет изменений в составе оборудования, услуг или автомобилей.'}
          action={null}
          icon={icon}
          table={table}
          data={history}
        />
      )}
    </>
  );
};

export default DealHistory;
